export default __webpack_public_path__ + "static/media/43_mobile.68ae796a.jpg";